module.exports = __webpack_public_path__ + "img/topic_bg_image.9bc552b.webp";